import Modulos from '../../classes/enums/Modulos'

export default [
  {
    path: 'configurations',
    name: 'configurationssa',
    redirect: { name: 'configurations/distributors' }
  },
  {
    path: 'configurations',
    name: 'configurations',
    redirect: { name: 'configurations/general' }
  },
  {
    path: 'configurations/users',
    name: 'configurations/users',
    component: () => import('@/views/configuration/Users.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'configurations/template/companies',
    name: 'configurations/template/companies',
    component: () => import('@/views/configuration/Template.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'configurations/template/groups',
    name: 'configurations/template/groups',
    component: () => import('@/views/configuration/TemplateGroup.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'configurations/users/:id/details',
    name: 'configurations/users/details',
    component: () => import('@/views/configuration/User.vue'),
    meta: { secondaryMenu: 'configurations/users', registerNavFromMenu: false }
  },
  {
    path: 'configurations/users/profile',
    name: 'configurations/users/profile',
    component: () => import('@/views/configuration/UserProfile.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'configurations/users/:id/companies',
    name: 'configurations/users/companies',
    component: () => import('@/views/configuration/Companies.vue'),
    meta: { secondaryMenu: 'configurations/users', registerNavFromMenu: false }
  },
  {
    path: 'configurations/users/:id/groups',
    name: 'configurations/users/groups',
    component: () => import('@/views/configuration/GroupsByUser.vue'),
    meta: { secondaryMenu: 'configurations/users', registerNavFromMenu: false }
  },
  {
    path: 'configurations/users/:id/status',
    name: 'configurations/users/status',
    component: () => import('@/views/configuration/StatusByUser.vue'),
    meta: { secondaryMenu: 'configurations/users', registerNavFromMenu: false }
  },
  {
    path: 'configurations/users/:id/providercompany',
    name: 'configurations/users/providercompany',
    component: () => import('@/views/configuration/CompanyProviderByUser.vue'),
    meta: { secondaryMenu: 'configurations/users', registerNavFromMenu: false }
  },
  {
    path: 'configurations/users/:id/historical',
    name: 'configurations/users/historical',
    component: () => import('@/views/historical/UserHistorical.vue'),
    meta: { secondaryMenu: 'configurations/users', registerNavFromMenu: false }
  },
  {
    path: 'configurations/clients',
    name: 'configurations/clients',
    component: () => import('@/views/clients/Clients.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'configurations/administrativecenters/:id/:idAdministrativeCenter/details',
    name: 'configurations/administrativecenters/details',
    component: () => import('@/views/configuration/AdministrativeCenter.vue'),
    meta: { secondaryMenu: 'configurations/administrativecenters', registerNavFromMenu: false }
  },
  {
    path: 'configurations/general',
    name: 'configurations/general',
    component: () => import('@/views/configuration/ClientAdmin.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'configurations/clients/:id/details',
    name: 'configurations/clients/details',
    component: () => import('@/views/clients/Client.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false }
  },
  {
    path: 'configurations/clients/:id/template/companies',
    name: 'configurations/clients/template/companies',
    component: () => import('@/views/configuration/Template.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false }
  },
  {
    path: 'configurations/clients/:id/template/groups',
    name: 'configurations/clients/template/groups',
    component: () => import('@/views/configuration/TemplateGroup.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false }
  },
  {
    path: 'configurations/clients/:id/modules',
    name: 'configurations/clients/modules',
    component: () => import('@/views/clients/Modules.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false }
  },
  {
    path: 'configurations/clients/:id/historical',
    name: 'configurations/clients/historical',
    component: () => import('@/views/historical/ClientHistorical.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false }
  },
  {
    path: 'configurations/groups',
    name: 'configurations/groups',
    component: () => import('@/views/configuration/Groups.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'configurations/groups/:id/details',
    name: 'configurations/groups/details',
    component: () => import('@/views/configuration/Group.vue'),
    meta: { secondaryMenu: 'configurations/groups', registerNavFromMenu: false }
  },
  {
    path: 'configurations/groups/:id/users',
    name: 'configurations/groups/users',
    component: () => import('@/views/configuration/UsersByGroup.vue'),
    meta: { secondaryMenu: 'configurations/groups', registerNavFromMenu: false }
  },
  {
    path: 'configurations/groups/:id/companies',
    name: 'configurations/groups/companies',
    component: () => import('@/views/configuration/CompaniesByGroup.vue'),
    meta: { secondaryMenu: 'configurations/groups', registerNavFromMenu: false }
  },
  {
    path: 'configurations/groups/:id/status',
    name: 'configurations/groups/status',
    component: () => import('@/views/configuration/StatusByGroup.vue'),
    meta: { secondaryMenu: 'configurations/groups', registerNavFromMenu: false }
  },
  {
    path: 'configurations/groups/:id/historical',
    name: 'configurations/groups/historical',
    component: () => import('@/views/historical/GroupHistorical.vue'),
    meta: { secondaryMenu: 'configurations/groups', registerNavFromMenu: false }
  },
  // Personalization
  {
    path: 'configurations/personalization',
    name: 'configurations/personalization',
    component: () => import('@/views/configuration/Personalization.vue'),
    meta: { registerNavFromMenu: false, modules: [[Modulos.CUENTA_CORREO_CLIENTE, Modulos.CORREOS_AVISOS_PERSONALIZADOS, Modulos.LOGO_PERSONALIZADO, Modulos.COLORES_PERSONALIZADOS]] }
  },
  {
    path: 'configurations/clients/:id/personalization',
    name: 'configurations/clients/personalization',
    component: () => import('@/views/configuration/Personalization.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, modules: [[Modulos.CUENTA_CORREO_CLIENTE, Modulos.CORREOS_AVISOS_PERSONALIZADOS, Modulos.LOGO_PERSONALIZADO, Modulos.COLORES_PERSONALIZADOS]] }
  },
  {
    path: 'configurations/pdftemplate',
    name: 'configurations/pdftemplate',
    component: () => import('@/views/configuration/XsltTemplate.vue'),
    meta: { registerNavFromMenu: false, modules: [[Modulos.GENERACION_FACTURAS_PDF]] }
  },
  {
    path: 'configurations/clients/:id/pdftemplate',
    name: 'configurations/clients/pdftemplate',
    component: () => import('@/views/configuration/XsltTemplate.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, modules: [[Modulos.GENERACION_FACTURAS_PDF]] }
  },
  // #region Autenthication Client
  {
    path: 'configurations/clients/:id/configAAD',
    name: 'configurations/clients/configAAD',
    component: () => import('@/views/configuration/ConfigAAD.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, modules: [[Modulos.INTEGRACION_AAD]] }
  },
  {
    path: 'configurations/clients/:id/configSAML2',
    name: 'configurations/clients/configSAML2',
    component: () => import('@/views/configuration/configSAML2.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, modules: [[Modulos.INTEGRACION_SAML2]] }
  },
  // #endregion
  // #region Webhooks
  {
    path: 'configurations/webhooks',
    name: 'configurations/webhooks',
    component: () => import('@/views/configuration/WebHooks.vue'),
    meta: { registerNavFromMenu: false, modules: [[Modulos.WEBHOOKS_EMITIDAS, Modulos.WEBHOOKS_RECIBIDAS]] }
  },
  {
    path: 'configurations/webhooks/:idWebHook/detail',
    name: 'configurations/webhooks/detail',
    component: () => import('@/views/configuration/WebHook.vue'),
    meta: { secondaryMenu: 'configurations/webhooks', registerNavFromMenu: false, modules: [[Modulos.WEBHOOKS_EMITIDAS, Modulos.WEBHOOKS_RECIBIDAS]] }
  },
  {
    path: 'configurations/webhooks/:idWebHook/historical',
    name: 'configurations/webhooks/historical',
    component: () => import('@/views/historical/WebhookHistorical.vue'),
    meta: { secondaryMenu: 'configurations/webhooks', registerNavFromMenu: false, modules: [[Modulos.WEBHOOKS_EMITIDAS, Modulos.WEBHOOKS_RECIBIDAS]] }
  },
  {
    path: 'configurations/clients/:id/webhooks',
    name: 'configurations/clients/webhooks',
    component: () => import('@/views/configuration/WebHooks.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, modules: [[Modulos.WEBHOOKS_EMITIDAS, Modulos.WEBHOOKS_RECIBIDAS]] }
  },
  {
    path: 'configurations/clients/:id/webhooks/:idWebHook/detail',
    name: 'configurations/clients/webhooks/detail',
    component: () => import('@/views/configuration/WebHook.vue'),
    meta: { secondaryMenu: 'configurations/clients/webhooks', registerNavFromMenu: false, modules: [[Modulos.WEBHOOKS_EMITIDAS, Modulos.WEBHOOKS_RECIBIDAS]] }
  },
  {
    path: 'configurations/clients/:id/webhooks/:idWebHook/historical',
    name: 'configurations/clients/webhooks/historical',
    component: () => import('@/views/historical/WebhookHistorical.vue'),
    meta: { secondaryMenu: 'configurations/clients/webhooks', registerNavFromMenu: false, modules: [[Modulos.WEBHOOKS_EMITIDAS, Modulos.WEBHOOKS_RECIBIDAS]] }
  },
  // #endregion
  // Distribuidores
  {
    path: 'configurations/distributors',
    name: 'configurations/distributors',
    component: () => import('@/views/distributors/Distributors.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'configurations/distributors/:id/details',
    name: 'configurations/distributors/details',
    component: () => import('@/views/distributors/Distributor.vue'),
    meta: { secondaryMenu: 'configurations/distributors', registerNavFromMenu: false }
  },
  {
    path: 'configurations/distributors/:id/modules',
    name: 'configurations/distributors/modules',
    component: () => import('@/views/distributors/Modules.vue'),
    meta: { secondaryMenu: 'configurations/distributors', registerNavFromMenu: false }
  },
  {
    path: 'configurations/distributors/:id/historical',
    name: 'configurations/distributors/historical',
    component: () => import('@/views/historical/DistributorHistorical.vue'),
    meta: { secondaryMenu: 'configurations/distributors', registerNavFromMenu: false }
  },
  
  // Personalization
  {
    path: 'configurations/personalization',
    name: 'configurations/personalization',
    component: () => import('@/views/configuration/Personalization.vue'),
    meta: { registerNavFromMenu: false, modules: [[Modulos.CUENTA_CORREO_CLIENTE, Modulos.CORREOS_AVISOS_PERSONALIZADOS, Modulos.LOGO_PERSONALIZADO, Modulos.COLORES_PERSONALIZADOS]] }
  },
  {
    path: 'configurations/clients/:id/personalization',
    name: 'configurations/clients/personalization',
    component: () => import('@/views/configuration/Personalization.vue'),
    meta: { secondaryMenu: 'configurations/clients', registerNavFromMenu: false, modules: [[Modulos.CUENTA_CORREO_CLIENTE, Modulos.CORREOS_AVISOS_PERSONALIZADOS, Modulos.LOGO_PERSONALIZADO, Modulos.COLORES_PERSONALIZADOS]] }
  },
  {
    path: 'configurations/template/clientspersonalization',
    name: 'configurations/template/clientspersonalization',
    component: () => import('@/views/distributors/TemplateClientPersonalization.vue'),
    meta: { registerNavFromMenu: false, modules: [[Modulos.CUENTA_CORREO_CLIENTE, Modulos.CORREOS_AVISOS_PERSONALIZADOS, Modulos.LOGO_PERSONALIZADO, Modulos.COLORES_PERSONALIZADOS]] }
  },
  {
    path: 'configurations/distributors/:id/template/clientspersonalization',
    name: 'configurations/distributors/template/clientspersonalization',
    component: () => import('@/views/distributors/TemplateClientPersonalization.vue'),
    meta: { secondaryMenu: 'configurations/distributors', registerNavFromMenu: false, modules: [[Modulos.CUENTA_CORREO_CLIENTE, Modulos.CORREOS_AVISOS_PERSONALIZADOS, Modulos.LOGO_PERSONALIZADO, Modulos.COLORES_PERSONALIZADOS]] }
  },
  {
    path: 'configurations/template/clientspdftemplate',
    name: 'configurations/template/clientspdftemplate',
    component: () => import('@/views/distributors/TemplateClientXslt.vue'),
    meta: { registerNavFromMenu: false, modules: [[Modulos.GENERACION_FACTURAS_PDF]] }
  },
  {
    path: 'configurations/distributors/:id/template/clientspdftemplate',
    name: 'configurations/distributors/template/clientspdftemplate',
    component: () => import('@/views/distributors/TemplateClientXslt.vue'),
    meta: { secondaryMenu: 'configurations/distributors', registerNavFromMenu: false, modules: [[Modulos.GENERACION_FACTURAS_PDF]] }
  },
  // Grouping
  {
    path: 'configurations/grouping/:id/companies',
    name: 'configurations/grouping/companies',
    component: () => import('@/views/grouping/Companies.vue'),
    meta: { secondaryMenu: 'configurations/grouping', registerNavFromMenu: false, modules: [[Modulos.AGRUPACIONES]] }
  },
  {
    path: 'configurations/grouping/:id/buyers',
    name: 'configurations/grouping/buyers',
    component: () => import('@/views/grouping/Clientes.vue'),
    meta: { secondaryMenu: 'configurations/grouping', registerNavFromMenu: false, modules: [[Modulos.AGRUPACIONES]] }
  },
  {
    path: 'configurations/grouping/:id/sellers',
    name: 'configurations/grouping/sellers',
    component: () => import('@/views/grouping/Proveedores.vue'),
    meta: { secondaryMenu: 'configurations/grouping', registerNavFromMenu: false, modules: [[Modulos.AGRUPACIONES]] }
  },
  {
    path: 'configurations/grouping/companies/main',
    name: 'configurations/grouping/companies/main',
    component: () => import('@/views/grouping/Companies.vue'),
    meta: { secondaryMenu: 'configurations/grouping/main', registerNavFromMenu: false, modules: [[Modulos.AGRUPACIONES]] }
  },
  {
    path: 'configurations/grouping/buyers/main',
    name: 'configurations/grouping/buyers/main',
    component: () => import('@/views/grouping/Clientes.vue'),
    meta: { secondaryMenu: 'configurations/grouping/main', registerNavFromMenu: false, modules: [[Modulos.AGRUPACIONES]] }
  },
  {
    path: 'configurations/grouping/sellers/main',
    name: 'configurations/grouping/sellers/main',
    component: () => import('@/views/grouping/Proveedores.vue'),
    meta: { secondaryMenu: 'configurations/grouping/main', registerNavFromMenu: false, modules: [[Modulos.AGRUPACIONES]] }
  },
  // Reglas
  {
    path: 'configurations/groups/:id/rules',
    name: 'configurations/groups/rules',
    component: () => import('@/views/configuration/RulesByGroup.vue'),
    meta: { secondaryMenu: 'configurations/groups', registerNavFromMenu: false }
  },
  {
    path: 'configurations/rules',
    name: 'configurations/rules',
    component: () => import('@/views/configuration/Rules.vue'),
    meta: { registerNavFromMenu: false }
  },
  {
    path: 'configurations/rules/:id/details',
    name: 'configurations/rules/details',
    component: () => import('@/views/configuration/Rule.vue'),
    meta: { secondaryMenu: 'configurations/rules', registerNavFromMenu: false }
  },
  {
    path: 'configurations/rules/:id/groups',
    name: 'configurations/rules/groups',
    component: () => import('@/views/configuration/GroupsByRule.vue'),
    meta: { secondaryMenu: 'configurations/rules', registerNavFromMenu: false }
  },
  {
    path: 'configurations/rules/:id/historical',
    name: 'configurations/rules/historical',
    component: () => import('@/views/historical/RuleHistorical.vue'),
    meta: { secondaryMenu: 'configurations/rules', registerNavFromMenu: false }
  },
  {
    path: 'configurations/imports',
    name: 'configurations/imports',
    component: () => import('@/views/configuration/Importaciones.vue'),
    meta: { registerNavFromMenu: false, modules: [[Modulos.IMPORTACIONES]] }
  }

]
